var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { DigitalWallet } from './DigitalWallet';
import { ShippingInformation } from './Shipping';
import { EmailInformation } from './Email';
import { CardInformation } from './Card';
import { BillingInformation } from './Billing';
import { Header } from './Header';
import { Submit } from './Submit';
import { useCartRequiresShipping, useFramePay, usePayment } from '../Providers';
import { OrderSummaryFooter } from '../UI/Footer';
import { Divider } from '../UI/Divider';
import { Toggles } from './Toggles';
import { Unavailable } from '../UI';
export var PaymentForm = function (_a) {
    var children = _a.children;
    var _b = usePayment(), paymentRef = _b.paymentRef, handleFocus = _b.handleFocus, handleBlur = _b.handleBlur, handleInput = _b.handleInput, handleChange = _b.handleChange;
    return (_jsx("form", __assign({ ref: paymentRef, onFocus: handleFocus, onChange: handleChange, onBlur: handleBlur, onInput: handleInput, noValidate: true }, { children: children })));
};
export var Payment = function () {
    var appearing = usePayment().appearing;
    var framePayEnabled = useFramePay().framePayEnabled;
    var requiresShipping = useCartRequiresShipping();
    return (_jsxs(Wrapper, { children: [framePayEnabled ? (_jsxs(_Fragment, { children: [_jsx(DigitalWallet, {}), _jsx(Divider, { children: "Or pay with card" })] })) : null, _jsxs(PaymentForm, { children: [_jsx(EmailInformation, {}), _jsx(Unavailable, __assign({ until: appearing ? 'ContactInfoComplete' : '' }, { children: _jsx(ShippingInformation, {}) })), _jsxs(Unavailable, __assign({ until: appearing ? (requiresShipping ? 'ShippingInfoComplete' : 'ContactInfoComplete') : '' }, { children: [_jsx(Header, { children: "Payment method" }), _jsx(CardInformation, {}), _jsx(BillingInformation, {})] })), _jsx(Toggles, {}), _jsx(Submit, {})] }), _jsx(OrderSummaryFooter, { "$mobileOnly": true })] }));
};
var Wrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: var(--section-width);\n  max-width: 100%;\n  margin: 0 auto;\n"], ["\n  position: relative;\n  width: var(--section-width);\n  max-width: 100%;\n  margin: 0 auto;\n"])));
var templateObject_1;
//# sourceMappingURL=Form.js.map